import { Component, input, inject, effect } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToolService } from '../../services/api-services/tools/tool.service';
import { MatDialog } from '@angular/material/dialog';
import { ToolRegistrationDialogComponent } from '../admin-area-list/tool-registration-dialog/tool-registration-dialog.component';
import { JobLogsDialComponent } from '../../utils/dialogues/job-logs-dial/job-logs-dial.component';
import { NotificationDialComponent } from '../../utils/dialogues/notification-dial/notification-dial.component';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-tool-config',
  templateUrl: './tool-config.component.html',
  styleUrls: ['./tool-config.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    CdkTextareaAutosize,
    MatButton,
  ],
})
export class ToolConfigComponent {
  /** Inject services. */
  private readonly toolService = inject(ToolService);
  private readonly dialogRef = inject(MatDialog);

  readonly toolId = input<number | undefined>(undefined);

  readonly tool = this.toolService.getToolConfigById(this.toolId);

  readonly installationLogs = this.toolService.getToolInstallationLogs(this.toolId);

  toolForm = new FormGroup({
    toolId: new FormControl(''),
    toolName: new FormControl(''),
    toolDescription: new FormControl(''),
    programLanguage: new FormControl(''),
    author: new FormControl(''),
    version: new FormControl(''),
    project: new FormControl(''),
    status: new FormControl(''),
  });

  constructor() {
    effect(() => {
      const tool = this.tool.value();
      if (!tool) return;
      this.toolForm.controls['toolId'].setValue(tool.toolId.toString());
      this.toolForm.controls['toolName'].setValue(tool.name);
      this.toolForm.controls['toolDescription'].setValue(tool.description);
      this.toolForm.controls['programLanguage'].setValue(tool.programLanguage);
      this.toolForm.controls['author'].setValue(tool.author);
      this.toolForm.controls['version'].setValue(tool.toolVersion);
      this.toolForm.controls['project'].setValue(tool.project);
      this.toolForm.controls['status'].setValue(tool.status);
    });
  }

  openRegistrations() {
    this.dialogRef.open(ToolRegistrationDialogComponent, {
      minWidth: '24rem',
      data: this.tool.value,
    });
  }

  openToolInstallationLogs() {
    this.dialogRef.open(JobLogsDialComponent, {
      data: this.installationLogs.value,
    });
  }

  async triggerToolReinstallation() {
    const tool = this.tool.value();
    if (!tool) return;
    this.dialogRef.open(NotificationDialComponent, {
      data: {
        title: 'Tool Installation Started',
        message: `The installation process for Tool ${tool.name} has now begun. Please refresh the page to view the updated installation status.`,
      },
    });
    await this.toolService.triggerToolReinstallation(tool.toolId);
  }
}
